import axios from 'axios';
import qs from 'qs';
import { BASE_URL } from './url';

const $api = axios.create({
    withCredentials: true,
    baseURL: BASE_URL,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
});

export default $api;
